module.exports = __webpack_public_path__ + "img/ic_check_red.3e981ce4.svg";